module.exports = __webpack_public_path__ + "static/media/ic-ad-banner15.1b203eef.png";